import { h } from "preact";
import { classNames } from "../../platform/preact/class-names.ts";
import type { IconProps } from "./icon.tsx";

export function IconBrandHollow({
  className,
  ...props
}: Omit<IconProps, "icon">) {
  return (
    <svg
      className={classNames(
        "component-icon",
        "component-icon-brand-hollow",
        className,
      )}
      {...props}
      viewBox="0 0 640 640"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M320 0C496.731 0 640 143.269 640 320C640 496.731 496.731 640 320 640C143.269 640 0 496.731 0 320C0 143.269 143.269 0 320 0ZM495.079 141.052C489.884 135.857 482.684 133.036 475.337 133.63H475.263C413.142 138.677 292.091 163.614 224.478 231.228C177.497 278.208 167.403 330.087 170.595 369.571C171.337 378.923 182.544 382.263 189.149 375.657L288.825 276.056C295.356 269.524 306.044 269.524 312.575 276.056C319.106 282.587 319.106 293.275 312.575 299.806L196.2 416.255C195.384 417.071 194.716 417.962 194.196 418.927L193.825 418.556L134.45 477.931C127.919 484.462 127.919 495.149 134.45 501.681C140.981 508.212 151.669 508.212 158.2 501.681L212.528 447.353C220.247 453.29 228.634 458.114 238.06 460.638C271.235 469.544 322.966 470.806 373.435 437.407C382.489 431.47 377.739 418.556 366.903 418.556H355.028C351.243 418.556 348.2 415.513 348.2 411.728C348.2 408.685 350.13 406.087 353.024 405.196L425.536 383.524C428.059 382.708 430.286 381.149 431.771 378.997C435.036 374.247 438.228 369.423 441.196 364.45C445.798 356.806 440.083 347.306 431.177 347.306H402.528C398.743 347.306 395.7 344.263 395.7 340.478C395.7 337.435 397.63 334.837 400.524 333.946L460.567 315.911C464.055 314.872 466.802 312.348 468.138 309.009C489.587 254.458 499.532 197.384 502.501 160.794C503.095 153.446 500.274 146.247 495.079 141.052Z"
        fill="#5686fe"
      />
    </svg>
  );
}
